/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum FittingPrioritizationReturnCodes {
    Success = 0,
    Failed = 1
  }
  